const formatRupiah = (amount) => {
  const formattedAmount = amount.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.');
  return `Rp ${formattedAmount}`;
};

export default formatRupiah;
